import React from 'react';
import { ArrowForward, CalendarMonth, UploadFile } from '@mui/icons-material';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../pages/ManagementList.css';

const destinations = [
  {
    title: '診療予約一覧',
    description: '登録された診療予約を検索・確認します。',
    path: '/appointments/list',
    icon: <CalendarMonth />,
  },
  {
    title: '時間外予約一覧',
    description: '指定した時間帯の外にある予約を確認します。',
    path: '/appointments/out-of-hours',
    icon: <CalendarMonth />,
  },
  {
    title: '予約CSVアップロード',
    description: 'CSVファイルを選択し、時間帯を設定して取り込みます。',
    path: '/appointments/upload',
    icon: <UploadFile />,
  },
];

const MedicalDataDashboard: React.FC = () => (
  <Box className="management-page">
    <div className="management-heading">
      <div>
        <h1>ダッシュボード</h1>
        <p>管理業務の入口</p>
      </div>
    </div>

    <Paper className="management-panel" elevation={0} sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography component="h2" sx={{ fontSize: 16, fontWeight: 700, mb: 1 }}>
        予約管理
      </Typography>
      <Typography sx={{ color: 'text.secondary', fontSize: 13, mb: 2.5 }}>
        アップロード履歴の表示には現在対応していません。登録された予約は一覧で確認できます。
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, gap: 1.5 }}>
        {destinations.map(({ title, description, path, icon }) => (
          <Paper
            key={path}
            variant="outlined"
            sx={{ p: 2, borderColor: '#dedbd7', borderRadius: '10px', boxShadow: 'none' }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Box sx={{ color: '#9f545c', lineHeight: 0 }}>{icon}</Box>
              <Typography component="h3" sx={{ fontSize: 14, fontWeight: 700 }}>{title}</Typography>
            </Box>
            <Typography sx={{ color: 'text.secondary', fontSize: 12, minHeight: { md: 36 }, mb: 1.5 }}>
              {description}
            </Typography>
            <Button component={Link} to={path} variant="outlined" size="small" endIcon={<ArrowForward />}>
              開く
            </Button>
          </Paper>
        ))}
      </Box>
    </Paper>
  </Box>
);

export default MedicalDataDashboard;
